<template>
  <div>
    <v-card-text class="py-0">
      <div>
        <numberForm
          label="最小数"
          v-model="regulationItem.rules.minimumFrequency"
        ></numberForm>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import numberForm from './forms/numberForm'

export default {
  name: 'Heading2Frequency',
  components: {
    numberForm
  },
  props: {
    regulationItem: {
      type: Object,
      required: true
    }
  }
}
</script>
